import { createContext, useContext } from 'react';
import type { SortState } from '@/components/ui/shared/Table/types';

export interface TableContextValue {
  sort?: SortState;
  onSortChange?: (sort: SortState) => void;
  selectable: boolean;
  selectedIds: ReadonlySet<string>;
  onSelectionChange?: (ids: Set<string>) => void;
  rowIds: string[];
  expandable: boolean;
}

const defaultValue: TableContextValue = {
  selectable: false,
  selectedIds: new Set(),
  rowIds: [],
  expandable: false
};

export const TableContext = createContext<TableContextValue>(defaultValue);

export function useTableContext(): TableContextValue {
  return useContext(TableContext);
}
